import React from 'react';
import ProjectFeatureListItem from './ProjectFeatureListItem';
import { Form, Card } from 'react-bootstrap';
import { getWarningIssues, getErrorIssues } from '../../../../../utils/validationSummary';
import { ASTRO_DIM_5, ASTRO_DIM_SENSOR } from '../../../../../utils/constantFeatures';

import { connect } from 'react-redux';

class ProjectFeatureList extends React.Component {

    renderList() {
        return Object.values(this.props.driverFeatureWithProperties).map(driverFeature => {
            if(driverFeature['displayName'] === ''){
                return null;
            }

            // AstroDimSensor already shows the Astro-5 schedule (via extraProperties) alongside the
            // sensor settings in astdimsens mode - don't also list Astro-5's own standalone card.
            if (driverFeature.name === ASTRO_DIM_5.shortName
                && this.props.opmodesSelected && this.props.opmodesSelected.name === ASTRO_DIM_SENSOR.shortName) {
                return null;
            }

            const errors = getErrorIssues(this.props.issueByProperty, driverFeature.properties);
            const warnings = getWarningIssues(this.props.issueByProperty, driverFeature.properties);

            return (
                <ProjectFeatureListItem
                    key={driverFeature.id}
                    driverFeature={driverFeature}
                    {...this.props}
                    errors={errors}
                    warnings={warnings}
                    isSelected={this.props.showedFeature && this.props.showedFeature.id === driverFeature.id}
                    isChecked={this.isChecked(driverFeature)} />
            );
        });
    }

    isChecked(driverFeature) {
        if (this.props.checkedFeatures) {
            const indexOfUnderscore = driverFeature.name.indexOf("_");
            const name = indexOfUnderscore >= 0 ? driverFeature.name.substring(0, indexOfUnderscore) : driverFeature.name;

            return this.props.checkedFeatures.indexOf(name) !== -1;
        }

        return false;
    }

    render() {

        if (!this.props.driverFeatureWithProperties) {
            return null;
        }

        return (
            <Card className="card-project-feature-list">
                <Card.Body className="card-body-feature-list-component">
                    <Form noValidate >
                        {this.renderList()}
                    </Form>
                </Card.Body>
            </Card>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
        issueByProperty: state.project.issueByProperty,
        opmodesSelected: state.driver.opmodesSelected
    };
};

const mapDispatchToProps = {
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ProjectFeatureList);
